import Rewardly from "@/src/screens/rewardly/rewardly";

export default function RewardlyScreen() {
	return <Rewardly/>
};
